document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".sign-in-form");

  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const attributes = {};

    for (let [key, value] of formData.entries()) {
      if (key.startsWith("attributes[") && key.endsWith("]")) {
        const attrKey = key.slice(11, -1);

        if (attributes[attrKey]) {
          if (Array.isArray(attributes[attrKey])) {
            attributes[attrKey].push(value);
          } else {
            attributes[attrKey] = [attributes[attrKey], value];
          }
        } else {
          attributes[attrKey] = value;
        }
      }
    }

    const sellingPlanCheckbox = document.querySelector(".subscription-block__wrapper .custom-select__input:checked");
    if (!sellingPlanCheckbox) {
      console.error("No selling plan selected");
      return;
    }
    const sellingPlanId = sellingPlanCheckbox.dataset.value;

    // You’ll need to store the variant ID somewhere in your form
    const selectedVariantId = form.dataset.variantId; // Example: <form class="sign-in-form" data-variant-id="12345"> for the box-plan product
    if (!selectedVariantId) {
      console.error("Missing variant ID on sign-in form");
      return;
    }

    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      let item = {
        id: parseInt(selectedVariantId),
        quantity: 1,
      }

      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            item,
          ],
        }),
      });

      if (!addRes.ok) throw new Error("Failed to add to cart");

      const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes }),
      });

      if (!updateRes.ok) throw new Error("Failed to update cart attributes");

      const cart = await updateRes.json();
      console.log("Cart updated with sign-in form data:", cart);
      window.location.href = "/checkout?discount=" + (sellingPlanCheckbox.dataset.shipping === 'true' ? "free_shipping" : "");
    } catch (err) {
      console.error("Form submission failed", err);
    }
  });

  let boxPlans = document.querySelectorAll(".box-plan__label");
  boxPlans.forEach((boxPlan) => {
    boxPlan.addEventListener("click", function () {
      boxPlans.forEach((bp) => bp.classList.remove("box-plan__label--selected"));
      this.classList.add("box-plan__label--selected");
      let variantId = this.querySelector('.box-plan__radio').value; // Assuming each box plan has a data-variant-id attribute
      form.dataset.variantId = variantId;
      let plans = document.querySelectorAll(".subscription-block__wrapper");
      plans.forEach((plan) => {
        plan.classList.add("subscription-block__wrapper--hidden");
      });
      let validPlans = document.querySelectorAll(`.subscription-block__wrapper[data-variant-id="${variantId}"]`);
      validPlans.forEach((plan) => {
        plan.classList.remove("subscription-block__wrapper--hidden");
      });
      validPlans[0].querySelector(".custom-select__input").checked = true; // Check the first plan by default
    });
  });

  let subscriptionPlans = document.querySelectorAll(".subscription-block__wrapper");
  subscriptionPlans.forEach((plan) => {
    plan.addEventListener("click", function () {
      plan.querySelector(".custom-select__input").click();
    });
  });

  const currentBoxPlan = document.querySelector(".box-plan__label--selected");
  if (currentBoxPlan) {
    form.dataset.variantId = currentBoxPlan.querySelector('.box-plan__radio').value; // Assuming each box plan has a data-variant-id attribute
  } else {
    form.dataset.variantId = document.querySelector(".subscription-block__wrapper").dataset.variantId; // Default to the first box plan
  }
});
